import { UrlMatchResult, UrlSegment } from '@angular/router';

const SUPPORTED_LANGS = ['en', 'fi', 'de', 'no', 'en-ca', 'en-nz', 'fr-ca', 'en-au', 'en-eu'];
export const ROOT_LANG = 'en-nz';
export const HIDDEN_LANG = 'en';

/**
 * Matches and validates language segments in Angular route URLs.
 *
 * This function checks if the first URL segment is a supported language code.
 * If a valid language is found, it returns a match result with the language segment
 * consumed and set as a route parameter. If no valid language is found, it returns null.
 *
 * @param segments The URL segments to match against supported languages
 * @returns A UrlMatchResult with the language segment if valid, or null if no match
 */
export function langMatcher(segments: UrlSegment[]): UrlMatchResult | null {
  const [firstSegment] = segments;
  if (firstSegment && SUPPORTED_LANGS.includes(firstSegment.path)) {
    return {
      consumed: [firstSegment],
      posParams: {
        lang: firstSegment
      }
    };
  }
  return null;
}

